import { render, staticRenderFns } from "./EditCustomerParameter.vue?vue&type=template&id=826b6762"
import script from "./EditCustomerParameter.vue?vue&type=script&lang=js"
export * from "./EditCustomerParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports